// Shopify's built-in HTML currency format for GHS renders "GH₵" — the
// owner's own labels and copy always use just "₵", so normalize it site-wide
// rather than fabricate an unsupported currency-format setting.
(function () {
  // Cedi sign written as a \uXXXX escape, not the raw character — Shopify's
  // asset minifier was observed corrupting the literal ₵ byte sequence
  // (turned it into garbled "âµ" inside the regex), which silently broke
  // this whole file. Escapes survive minification untouched.
  var CEDI = '₵';
  var GH_CEDI_RE = new RegExp('GH\\s?' + CEDI, 'g');
  function fixCurrency(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue.indexOf('GH' + CEDI) !== -1 || node.nodeValue.indexOf('GH ' + CEDI) !== -1) {
        node.nodeValue = node.nodeValue.replace(GH_CEDI_RE, CEDI);
      }
    }
  }
  function init() {
    fixCurrency(document.body);
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType === 1) fixCurrency(n);
          else if (n.nodeType === 3 && (n.nodeValue.indexOf('GH' + CEDI) !== -1 || n.nodeValue.indexOf('GH ' + CEDI) !== -1)) {
            n.nodeValue = n.nodeValue.replace(GH_CEDI_RE, CEDI);
          }
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.body) init();
  else document.addEventListener('DOMContentLoaded', init);
})();

// Native share sheet (mobile) / copy-link fallback (desktop) for the
// per-card and product-page share buttons. Defined on window so inline
// onclick="" handlers rendered anywhere in the theme can call it. This lives
// in a real theme asset (not an inline <script> in theme.liquid) because
// Horizon's client-side page morphing (@theme/morph, used for its
// view-transitions / instant-navigation system) re-inserts server-rendered
// HTML in a way that never executes inline <script> tags — confirmed this
// affects Shopify's OWN inline scripts too (window.Theme, set by Horizon's
// own inline bootstrap script, was equally undefined). External script src
// files are unaffected and always execute.
function kjShowToast(text) {
  var toast = document.createElement('div');
  toast.textContent = text;
  toast.style.cssText = 'position:fixed;left:50%;bottom:90px;transform:translateX(-50%);background:#2B2B22;color:#fff;padding:10px 20px;border-radius:20px;font-size:14px;font-weight:600;z-index:9999;box-shadow:0 4px 16px rgba(0,0,0,0.25);';
  document.body.appendChild(toast);
  setTimeout(function () { toast.remove(); }, 2200);
}

function kjCopyFallback(url) {
  // Try the modern Clipboard API first (can silently fail on http, in an
  // iframe, or without a permissions grant), then a legacy execCommand
  // fallback, then finally a visible prompt so the user always gets
  // *something* rather than a click that appears to do nothing.
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(url).then(function () {
      kjShowToast('Link copied!');
    }).catch(function () { kjLegacyCopy(url); });
  } else {
    kjLegacyCopy(url);
  }
}

function kjLegacyCopy(url) {
  try {
    var input = document.createElement('textarea');
    input.value = url;
    input.style.position = 'fixed';
    input.style.opacity = '0';
    document.body.appendChild(input);
    input.focus();
    input.select();
    var ok = document.execCommand('copy');
    document.body.removeChild(input);
    if (ok) { kjShowToast('Link copied!'); return; }
  } catch (e) {}
  window.prompt('Copy this link to share:', url);
}

// Note: no pointer-type gatekeeping — navigator.share() works on desktop
// too (e.g. Windows 11 triggers its native share flyout), not just touch
// devices, so it's tried first everywhere it exists.
window.kjShare = function (anchor, data) {
  if (navigator.share) {
    navigator.share(data).catch(function (err) {
      // AbortError just means the user closed the native share sheet —
      // that's not a failure, don't fall back for it.
      if (err && err.name === 'AbortError') return;
      kjCopyFallback(data.url);
    });
    return;
  }
  kjCopyFallback(data.url);
};

// Bound directly on each [data-kj-share] button, not via document-level
// delegation — Horizon's own web components (product-form-component etc.)
// may call stopPropagation() on click events internally, which would
// swallow a click before it ever reaches a document-level listener.
// Binding on the element itself can't be defeated that way. Re-scans
// periodically via MutationObserver since Horizon's client-side section
// morphing can replace card markup with fresh nodes that need re-binding
// (same reasoning as the currency-fix walker above).
function kjBindShareButtons(root) {
  if (!root.querySelectorAll) return;
  var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-kj-share]'));
  if (root.matches && root.matches('[data-kj-share]')) buttons.push(root);
  for (var i = 0; i < buttons.length; i++) {
    var btn = buttons[i];
    if (btn.dataset.kjShareBound) continue;
    btn.dataset.kjShareBound = '1';
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      window.kjShare(this, { title: this.getAttribute('data-share-title') || document.title, url: this.getAttribute('data-share-url') || location.href });
    });
  }
}
function kjInitShareButtons() {
  kjBindShareButtons(document);
  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (n) {
        if (n.nodeType === 1) kjBindShareButtons(n);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
}
if (document.body) kjInitShareButtons();
else document.addEventListener('DOMContentLoaded', kjInitShareButtons);

// Video slider (kj-video-slider.liquid): simple prev/next + dots between
// videos, one active at a time. Lives here rather than an inline <script>
// in the section file for the same morph-re-render reason as the share
// buttons above.
function kjBindVideoSliders(root) {
  if (!root.querySelectorAll) return;
  var sliders = Array.prototype.slice.call(root.querySelectorAll('[data-kjvs-slider]'));
  if (root.matches && root.matches('[data-kjvs-slider]')) sliders.push(root);
  sliders.forEach(function (slider) {
    if (slider.dataset.kjvsBound) return;
    slider.dataset.kjvsBound = '1';
    var track = slider.querySelector('[data-kjvs-track]');
    var slides = Array.prototype.slice.call(track.querySelectorAll('.kjvs__slide'));
    var dots = Array.prototype.slice.call(slider.querySelectorAll('[data-kjvs-dot]'));
    if (!slides.length) return;
    var index = 0;

    function show(i) {
      slides[index].classList.remove('is-active');
      if (dots[index]) dots[index].classList.remove('is-active');
      index = (i + slides.length) % slides.length;
      slides[index].classList.add('is-active');
      if (dots[index]) dots[index].classList.add('is-active');
      var vid = slides[index].querySelector('video');
      if (vid) {
        vid.currentTime = 0;
        vid.play().catch(function () {});
      }
    }

    var prev = slider.querySelector('[data-kjvs-prev]');
    var next = slider.querySelector('[data-kjvs-next]');
    if (prev) prev.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { show(i); });
    });
  });
}
function kjInitVideoSliders() {
  kjBindVideoSliders(document);
  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (n) {
        if (n.nodeType === 1) kjBindVideoSliders(n);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
}
if (document.body) kjInitVideoSliders();
else document.addEventListener('DOMContentLoaded', kjInitVideoSliders);

// Per-card "Add to Cart" forms (kj-card-atc-form): a plain HTML form POST
// to /cart/add would navigate the whole page to wherever Shopify redirects
// it (in practice /cart), which reads to shoppers like "Add to Cart took me
// away from what I was browsing." Intercepted via fetch instead so adding
// an item never navigates anywhere — the shopper stays right where they
// were, sees a toast, and the header cart bubble updates in place.
function kjBindAddToCartForms(root) {
  if (!root.querySelectorAll) return;
  var forms = Array.prototype.slice.call(root.querySelectorAll('.kj-card-atc-form'));
  if (root.matches && root.matches('.kj-card-atc-form')) forms.push(root);
  for (var i = 0; i < forms.length; i++) {
    var form = forms[i];
    if (form.dataset.kjAtcBound) continue;
    form.dataset.kjAtcBound = '1';
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var form = this;
      var btn = form.querySelector('.kj-card-atc');
      var originalText = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'application/json' },
        body: new URLSearchParams(new FormData(form)),
      })
        .then(function (res) { if (!res.ok) throw new Error('add to cart failed'); return res.json(); })
        .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
        .then(function (cart) {
          var cartIcon = document.querySelector('cart-icon');
          if (cartIcon && typeof cartIcon.renderCartBubble === 'function') {
            cartIcon.renderCartBubble(cart.item_count);
          }
          kjShowToast('Added to cart!');
        })
        .catch(function () {
          kjShowToast("Couldn't add to cart — please try again.");
        })
        .finally(function () {
          if (btn) { btn.disabled = false; btn.textContent = originalText; }
        });
    });
  }
}
function kjInitAddToCartForms() {
  kjBindAddToCartForms(document);
  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (n) {
        if (n.nodeType === 1) kjBindAddToCartForms(n);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
}
if (document.body) kjInitAddToCartForms();
else document.addEventListener('DOMContentLoaded', kjInitAddToCartForms);

// "Back" link (kj-back-link.liquid): prefers real browser history so it
// returns to wherever the shopper actually came from (a collection, a
// search, the homepage) instead of always landing on one fixed page. Falls
// back to the section's configured link only when there's nowhere on this
// site to go back to (e.g. someone opened the product page directly).
function kjBindBackLinks(root) {
  if (!root.querySelectorAll) return;
  var links = Array.prototype.slice.call(root.querySelectorAll('[data-kj-back]'));
  if (root.matches && root.matches('[data-kj-back]')) links.push(root);
  for (var i = 0; i < links.length; i++) {
    var link = links[i];
    if (link.dataset.kjBackBound) continue;
    link.dataset.kjBackBound = '1';
    link.addEventListener('click', function (e) {
      var cameFromThisSite = document.referrer && document.referrer.indexOf(location.origin) === 0;
      if (cameFromThisSite && window.history.length > 1) {
        e.preventDefault();
        window.history.back();
      }
      // else: let the default href navigate to the fallback link.
    });
  }
}
function kjInitBackLinks() {
  kjBindBackLinks(document);
  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (n) {
        if (n.nodeType === 1) kjBindBackLinks(n);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
}
if (document.body) kjInitBackLinks();
else document.addEventListener('DOMContentLoaded', kjInitBackLinks);
